import type { Report, ApiResponse } from './types';
import { apiGet, apiPost } from '../services/api';

export async function generateReport(traceId: string, scoreId: string): Promise<Report> {
  try {
    const res = await apiPost<ApiResponse<Report>>('/reports', {
      trace_id: traceId,
      score_id: scoreId,
    });
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to generate report');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function getReport(id: string): Promise<Report> {
  try {
    const res = await apiGet<ApiResponse<Report>>(`/reports/${id}`);
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to fetch report');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}

export async function listReports(): Promise<Report[]> {
  try {
    const res = await apiGet<ApiResponse<Report[]>>('/reports');
    if (!res.success || !res.data) {
      throw new Error(res.error ?? 'Failed to fetch reports');
    }
    return res.data;
  } catch (err) {
    if (err instanceof TypeError && err.message === 'Failed to fetch') {
      throw new Error('Network error: unable to reach the server');
    }
    throw err;
  }
}